import { render, staticRenderFns } from "./ReportsModal.vue?vue&type=template&id=06a58472&lang=pug"
import script from "./ReportsModal.vue?vue&type=script&lang=js"
export * from "./ReportsModal.vue?vue&type=script&lang=js"
import style0 from "./ReportsModal.vue?vue&type=style&index=0&id=06a58472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports